import HttpClientToken from '../../services/HttpClientToken';

import { defaultMateria, MateriaProps } from '../../interfaces/catalogos/MateriaInterface';

export const Materia = () => {

    return new Promise<MateriaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Materia/', token)
            .then( ({ data } : { data : MateriaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerMateria = () => {

    return new Promise<MateriaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Materia/ObtenerMateria', token)
            .then( ({ data } : { data : MateriaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarMateria = ( params: MateriaProps ) => {

    return new Promise<MateriaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Materia/Actualizar', params, token)
            .then( ({ data } : { data : MateriaProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultMateria } );
            });

        }

    });

}

export const AgregarMateria = ( params: MateriaProps ) => {

    return new Promise<MateriaProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Materia/Agregar', params, token)
            .then( ({ data } : { data : MateriaProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultMateria } );
            });

        }

    });

}
